import i18next from 'i18next';
import { useCallback } from 'react';

// eslint-disable-next-line import/no-named-as-default-member
const fixedT = i18next.getFixedT.bind(i18next)(null, 'forms', 'text');

interface TextValidationProps {
  required: boolean;
  min?: number;
  max?: number;
  t?: (key: string, options?: Record<string, unknown>) => string;
}

type validatorFunction = (value: string) => string | null;

export function useTextValidator({ required, min, max, t = fixedT }: TextValidationProps): validatorFunction {
  return useCallback<validatorFunction>(
    (value: string) => {
      if (required && !value) {
        return t('missing');
      }

      if (!required && !value) {
        return null;
      }

      if (min === max && ((min && value.length < min) || (max && value.length > max))) {
        return t('invalidLength', { value, min, max });
      }

      if (min && value.length < min) {
        return t('tooSmall', { value, min });
      }

      if (max && value.length > max) {
        return t('tooLong', { value, max });
      }
    },
    [required, min, max, t]
  );
}
